import React, { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

const SubscriptionManagementPrototypePage = lazy(async () => {
  const module: unknown =
    await import('@/pages/Prototype/prototypes/SubscriptionManagementPrototype');

  if (
    typeof module === 'object' &&
    module !== null &&
    'SubscriptionManagementPrototype' in module
  ) {
    return {
      default: (
        module as { SubscriptionManagementPrototype: React.ComponentType }
      ).SubscriptionManagementPrototype,
    };
  }

  throw new Error('SubscriptionManagementPrototype export is unavailable');
});

const EstateLockerPrototypePage = lazy(async () => {
  const module: unknown =
    await import('@/pages/Prototype/prototypes/EstateLockerPage');

  if (
    typeof module === 'object' &&
    module !== null &&
    'EstateLockerPage' in module
  ) {
    return {
      default: (module as { EstateLockerPage: React.ComponentType })
        .EstateLockerPage,
    };
  }

  throw new Error('EstateLockerPage export is unavailable');
});

const FormBuilderPrototypePage = lazy(async () => {
  const module: unknown =
    await import('@/pages/Prototype/prototypes/FormBuilderPrototype');

  if (
    typeof module === 'object' &&
    module !== null &&
    'FormBuilderPrototype' in module
  ) {
    return {
      default: (module as { FormBuilderPrototype: React.ComponentType })
        .FormBuilderPrototype,
    };
  }

  throw new Error('FormBuilderPrototype export is unavailable');
});

const LegacyContactPage = lazy(async () => {
  const module: unknown =
    await import('@/pages/Prototype/prototypes/LegacyContactPage');

  if (
    typeof module === 'object' &&
    module !== null &&
    'LegacyContactPage' in module
  ) {
    return {
      default: (module as { LegacyContactPage: React.ComponentType })
        .LegacyContactPage,
    };
  }

  throw new Error('LegacyContactPage export is unavailable');
});

const DeathCertificateVerificationPage = lazy(async () => {
  const module: unknown =
    await import('@/pages/Prototype/prototypes/DeathCertificateVerificationPage');

  if (
    typeof module === 'object' &&
    module !== null &&
    'DeathCertificateVerificationPage' in module
  ) {
    return {
      default: (
        module as { DeathCertificateVerificationPage: React.ComponentType }
      ).DeathCertificateVerificationPage,
    };
  }

  throw new Error('DeathCertificateVerificationPage export is unavailable');
});

export const PrototypeRoutes = () => {
  const routes = [
    <Route
      path='/prototypes/subscription-management'
      element={<SubscriptionManagementPrototypePage />}
    />,
    <Route
      path='/prototypes/estate-locker'
      element={<EstateLockerPrototypePage />}
    />,
    <Route path='/prototypes/legacy-contact' element={<LegacyContactPage />} />,
    <Route
      path='/prototypes/form-builder'
      element={<FormBuilderPrototypePage />}
    />,
    <Route
      path='/prototypes/death-certificate'
      element={<DeathCertificateVerificationPage />}
    />,
  ];
  return routes;
};
